import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, renderList as _renderList, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ed6dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_c" }
const _hoisted_2 = { class: "mod_c_title section_live_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "资源概况", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "购买资源", -1))
const _hoisted_5 = { class: "mod_c_tbody home_media_wrap" }
const _hoisted_6 = {
  key: 0,
  class: "home_section_item_text"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并发数：", -1))
const _hoisted_8 = { class: "hsit_detail" }
const _hoisted_9 = {
  key: 1,
  class: "home_section_item_text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观看时长：", -1))
const _hoisted_11 = { class: "hsit_detail" }
const _hoisted_12 = {
  key: 2,
  class: "home_section_item_text"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "流量：", -1))
const _hoisted_14 = { class: "hsit_detail" }
const _hoisted_15 = { class: "cchars_wrap" }
const _hoisted_16 = { class: "cchars_wrap" }
const _hoisted_17 = {
  key: 1,
  class: "home_section_item_text"
}
const _hoisted_18 = { class: "m_10" }
const _hoisted_19 = { class: "home_section_item_caption" }
const _hoisted_20 = { class: "title lived" }
const _hoisted_21 = { class: "home_section_item_caption" }
const _hoisted_22 = { class: "title live_notice" }
const _hoisted_23 = { class: "home_section_item_caption" }
const _hoisted_24 = { class: "title living" }
const _hoisted_25 = { class: "home_section_item_caption" }
const _hoisted_26 = { class: "title lived" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "hsit_detail" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home_section_item_text" }, [
  /*#__PURE__*/_createElementVNode("span", null, "媒体库：")
], -1))
const _hoisted_30 = { class: "media_box" }
const _hoisted_31 = { class: "hsit_detail" }
const _hoisted_32 = { class: "mod_c" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mod_c_title" }, "直播信息", -1))
const _hoisted_34 = { class: "mod_c_tbody live_char" }
const _hoisted_35 = { class: "home_section_item_caption" }
const _hoisted_36 = { class: "title lived" }
const _hoisted_37 = { class: "home_section_item_caption" }
const _hoisted_38 = { class: "title live_notice" }
const _hoisted_39 = { class: "home_section_item_caption" }
const _hoisted_40 = { class: "title living" }
const _hoisted_41 = { class: "mod_c" }
const _hoisted_42 = { class: "mod_c_title section_live_title" }
const _hoisted_43 = { class: "pleft_btn" }
const _hoisted_44 = { class: "nav_ninetyNine" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "99元开播", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "新建直播", -1))
const _hoisted_47 = { class: "mod_nav_btn_title" }
const _hoisted_48 = { class: "mod_c_tbody home_tbody" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "content_square" }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "empty_wrap" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "empty_btn" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "快来开启第一场直播吧！", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "新建直播", -1))
const _hoisted_57 = { class: "home_section_right animated-in-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountInfo = _resolveComponent("AccountInfo")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConcurrentChars = _resolveComponent("ConcurrentChars")!
  const _component_watchChars = _resolveComponent("watchChars")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_MediaChars = _resolveComponent("MediaChars")!
  const _component_LiveChars = _resolveComponent("LiveChars")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_LiveItemSquare = _resolveComponent("LiveItemSquare")!
  const _component_app_link = _resolveComponent("app-link")!
  const _component_LiveItemBar = _resolveComponent("LiveItemBar")!
  const _component_OfferSider = _resolveComponent("OfferSider")!
  const _component_c_Modal = _resolveComponent("c-Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AccountInfo, {
      "data-source": _ctx.homeInfo.userInfo
    }, null, 8, ["data-source"]),
    _createElementVNode("div", {
      class: _normalizeClass([{ showInfo: _ctx.showInfo && _ctx.OfferSideRole }, "home_section"])
    }, [
      _createVNode(_component_a_row, {
        gutter: [16, 16],
        wrap: true,
        style: _normalizeStyle({ width: ' calc(100% - -7px)', height: _ctx.showInfo && _ctx.OfferSideRole ? '100%' : '' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            class: "home_section_item",
            lg: 10,
            md: 24,
            xs: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  (_ctx.ResourcePurchRole)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "nav_btn_link",
                        to: "/wallet/resource"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { class: "mod_btn_primary actived purchase_btn" }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_svg_icon, {
                                class: "mod_nav_btn_icon",
                                "icon-class": "purchase"
                              })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("div", null, [
                    (!_ctx.homeStore.concurrencyChartVisible)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.tollMode === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("span", _hoisted_8, [
                                  _createTextVNode("实时并发："),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.calssArr[_ctx.concurrentCharData.status])
                                  }, _toDisplayString(_ctx.concurrentCharData.used_count) + "人", 3),
                                  _createTextVNode("/" + _toDisplayString(_ctx.concurrentCharData.total) + "人", 1)
                                ])
                              ]))
                            : (_ctx.tollMode === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _hoisted_10,
                                  _createElementVNode("span", _hoisted_11, [
                                    _createTextVNode("已使用："),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.calssArr[_ctx.watchData.status])
                                    }, _toDisplayString(_ctx.watchData.used) + "分钟", 3),
                                    _createTextVNode("/" + _toDisplayString(_ctx.watchData.total) + "分钟", 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                          (_ctx.tollMode === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("span", _hoisted_14, [
                                  _createTextVNode("已使用："),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.calssArr[_ctx.watchData.status])
                                  }, _toDisplayString(_ctx.watchData.used), 3),
                                  _createTextVNode("/" + _toDisplayString(_ctx.watchData.total) + "分钟", 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _withDirectives(_createVNode(_component_ConcurrentChars, { "data-source": _ctx.concurrentCharData }, null, 8, ["data-source"]), [
                                [_vShow, !_ctx.tollMode]
                              ]),
                              _withDirectives(_createVNode(_component_watchChars, { "data-source": _ctx.watchData }, null, 8, ["data-source"]), [
                                [_vShow, _ctx.tollMode == 1 || _ctx.tollMode == 2]
                              ])
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.tollMode == 0 ? '并发数' : _ctx.tollMode == 1 ? '观看时长' : '流量') + "：", 1),
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xl: 24,
                                lg: 24,
                                md: 24,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.tollMode == 0)
                                    ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            xl: 8,
                                            xs: 8
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", _hoisted_19, [
                                                _createElementVNode("span", _hoisted_20, "中国内地：" + _toDisplayString(_ctx.concurrentCharData.used), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            xl: 8,
                                            xs: 8
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", _hoisted_21, [
                                                _createElementVNode("span", _hoisted_22, "国际/港澳台：" + _toDisplayString(_ctx.concurrentCharData.used_en), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            xl: 8,
                                            xs: 8
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", _hoisted_23, [
                                                _createElementVNode("span", _hoisted_24, "实时并发：" + _toDisplayString(_ctx.concurrentCharData.used_count), 1)
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : (_ctx.tollMode == 1)
                                      ? (_openBlock(), _createBlock(_component_a_col, {
                                          key: 1,
                                          span: 24
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, {
                                                  xl: 12,
                                                  md: 24,
                                                  xs: 24
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("p", _hoisted_25, [
                                                      _createElementVNode("span", _hoisted_26, "已使用：" + _toDisplayString(_ctx.watchData.used) + " 分钟", 1)
                                                    ])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_a_col, {
                                                  xl: 12,
                                                  md: 24,
                                                  xs: 24
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createVNode(_component_watchChars, { "data-source": _ctx.watchData }, null, 8, ["data-source"]),
                                          _createElementVNode("span", _hoisted_28, [
                                            _createTextVNode("已使用："),
                                            _createElementVNode("i", {
                                              class: _normalizeClass(_ctx.calssArr[_ctx.watchData.status])
                                            }, _toDisplayString(_ctx.watchData.used) + "GB", 3),
                                            _createTextVNode("/" + _toDisplayString(_ctx.watchData.total) + "GB", 1)
                                          ])
                                        ]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                  ], 512), [
                    [_vShow, _ctx.tollMode != null]
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_MediaChars, { "data-source": _ctx.mediaCharData }, null, 8, ["data-source"]),
                      _createElementVNode("span", _hoisted_31, [
                        _createTextVNode("已使用："),
                        _createElementVNode("i", {
                          class: _normalizeClass(_ctx.calssArr[_ctx.mediaCharData.status])
                        }, _toDisplayString(_ctx.mediaCharData.used) + "GB", 3),
                        _createTextVNode("/" + _toDisplayString(_ctx.mediaCharData.total) + "GB", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            class: "home_section_item",
            lg: 14,
            md: 24,
            xs: 24,
            style: _normalizeStyle({ paddingRight: _ctx.showInfo === 0 && _ctx.OfferSideRole ? '0px' : '10px' })
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xl: 5,
                        lg: 10,
                        md: 24,
                        xs: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xl: 24,
                                lg: 24,
                                md: 8,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_35, [
                                    _createElementVNode("span", _hoisted_36, "累计直播：" + _toDisplayString(_ctx.homeInfo.liveInfo.all_number), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xl: 24,
                                lg: 24,
                                md: 8,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_37, [
                                    _createElementVNode("span", _hoisted_38, "预告直播：" + _toDisplayString(_ctx.homeInfo.liveInfo.wait_live), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xl: 24,
                                lg: 24,
                                md: 8,
                                xs: 24
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_39, [
                                    _createElementVNode("span", _hoisted_40, "正在直播：" + _toDisplayString(_ctx.homeInfo.liveInfo.living), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xl: 19,
                        lg: 14,
                        md: 24,
                        xs: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_LiveChars, { "data-source": _ctx.liveCharData }, null, 8, ["data-source"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_a_col, {
            class: "home_section_item",
            span: 24,
            style: _normalizeStyle({ paddingRight: _ctx.showInfo === 0 && _ctx.OfferSideRole ? '0px' : '10px' })
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("h3", _hoisted_42, [
                  _createTextVNode(" 近期直播 "),
                  _createVNode(_component_a_button, {
                    class: "home_link_more",
                    type: "link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/live" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 更多>>")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_43, [
                    (_ctx.ninePMTRole)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "nav_btn_link",
                          to: { name: 'newLive', params: { title: false } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createVNode(_component_svg_icon, {
                                class: "hot_icon",
                                id: "hotId",
                                "icon-class": "hotIcon"
                              })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      class: "nav_btn_link",
                      to: "",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toCertify()), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { class: "mod_btn_primary actived crumb" }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "mod_nav_btn_icon",
                              "icon-class": "nav_btn_newlive"
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      class: "nav_btn_link",
                      to: "",
                      onClick: _ctx.switchView
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "link",
                          class: "mod_btn_primary switch_btn actived crumb"
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              class: "btn_icon",
                              "icon-class": _ctx.getCutoverIcon
                            }, null, 8, ["icon-class"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.getCutoverName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                (!_ctx.showLoading)
                  ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_48, [
                  (_ctx.liveList.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liveList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.id
                              }, [
                                _createVNode(_component_app_link, {
                                  to: `/live_set/${item.id}/broad_cast_control`
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_LiveItemSquare, {
                                      "data-source": item,
                                      "onClick:showLoading": _ctx.copyShowLoading
                                    }, null, 8, ["data-source", "onClick:showLoading"])
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            }), 128))
                          ])
                        ], 512), [
                          [_vShow, _ctx.cutoverView]
                        ]),
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_a_row, { gutter: [16, 16] }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liveList, (item) => {
                                return (_openBlock(), _createBlock(_component_a_col, {
                                  key: item.id,
                                  class: "gutter-row",
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_app_link, {
                                      to: `/live_set/${item.id}/broad_cast_control`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_LiveItemBar, {
                                          "data-source": item,
                                          QRCode: "",
                                          "onClick:showLoading": _ctx.copyShowLoading
                                        }, null, 8, ["data-source", "onClick:showLoading"])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, !_ctx.cutoverView]
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("img", {
                            class: "empty_tbody_img",
                            src: _ctx.emptyData,
                            alt: ""
                          }, null, 8, _hoisted_53),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createVNode(_component_a_button, {
                                class: "mod_btn_primary actived crumb",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toCertify()))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_svg_icon, {
                                    class: "mod_nav_btn_icon",
                                    "icon-class": "nav_btn_newlive"
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_56
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ]))
                ], 512), [
                  [_vShow, _ctx.showLoading]
                ])
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_Transition, { name: "private_list" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_57, [
            _createVNode(_component_OfferSider, {
              ref: "baseInfoRef",
              class: "offer_wrap",
              onShowStatused: _ctx.getShowStatus
            }, null, 8, ["onShowStatused"])
          ], 512), [
            [_vShow, _ctx.showInfo && _ctx.OfferSideRole]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "section_unfold",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unfoldClick && _ctx.unfoldClick(...args)))
      }, [
        _withDirectives(_createVNode(_component_svg_icon, {
          class: "fold_icon",
          iconClass: "unfold"
        }, null, 512), [
          [_vShow, _ctx.showInfo === 1 && _ctx.OfferSideRole]
        ]),
        _withDirectives(_createVNode(_component_svg_icon, {
          class: "fold_icon",
          iconClass: "fold"
        }, null, 512), [
          [_vShow, _ctx.showInfo === 0 && _ctx.OfferSideRole]
        ])
      ])
    ], 2),
    _createVNode(_component_c_Modal, {
      visible: _ctx.isVisible,
      close: _ctx.isopenDelModal,
      centered: ""
    }, null, 8, ["visible", "close"])
  ]))
}